<template>
    <div>
        <section class="content gray">
            <div class="container pt-5">
                <span class="left-aligned-title">Inbox</span>
                <div class="points-transaction section">
                    <div class="info-container">
                        <form>
                            <div class="form-group card-selector">
                                <div class="row mt-3">
                                    <div class="col-lg-4">
                                        <input type="text"
                                            class="form-control"
                                            id="search_box"
                                            placeholder="Search your inbox"
                                            name="search_box"
                                            v-model="mailListFrom.keyword"
                                            @keyup="getMailList()" />
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="filter-nav">
                                        <a @click="getMailList('all')" id="tab_all" class="active">All <span>({{ countInbox }})</span></a> |
                                        <a @click="getMailList('unread')" id="tab_unread">Unread <span>({{ countUnreadInbox }})</span></a> |
                                        <a @click="getMailList('read')" id="tab_read">Read <span>({{ countReadInbox }})</span></a> |
                                        <a @click="getMailList('deleted')" id="tab_deleted">Deleted <span>({{ countDeletedInbox }})</span></a>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>

        <section class="mail_list">
            <section class="content">
                <div class="container inbox-table">
            <ul class="inbox-filter-wrapper">
                <li>
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="customCheck">
                        <label class="custom-control-label" for="customCheck"></label>
                    </div>
                </li>
                <li><a @click="mailAction('read')"><img :src="messageImage" alt="Get Rewarded"/>Mark as Read</a></li>
                <li><a @click="mailAction('deleted')"><img :src="deleteImage" alt="Get Rewarded"/>Delete</a></li>
            </ul>

            <table class="table inbox-hover">
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <!--unread-->
                    <tr
                        v-bind:class="[mail.mail_status == 'unread' ? activeClass : inactiveClass]"
                        v-for="mail in mail_list"
                        :key="mail.id"
                        >
                        <td>
                            <div class="custom-control custom-checkbox">
                                <input
                                    type="checkbox"
                                    v-model="updateStatusForm.selectedId"
                                    class="custom-control-input"
                                    :value="mail.id"
                                    :id="'customCheck'+mail.id"
                                    @change="check($event)">
                                <label class="custom-control-label" :for="'customCheck'+mail.id"></label>
                            </div>
                        </td>
                        <td @click="getMailDetail(mail.id)"><b>{{ mail.from_username }}</b></td>
                        <td @click="getMailDetail(mail.id)"><b>{{ mail.subject }}</b><br>{{ mail.title }}</td>
                        <td @click="getMailDetail(mail.id)">{{ mail.receive_date }}</td>
                    </tr>
                </tbody>
            </table>
            <paginate
              v-if="mailListFrom.totalPage > 1"
              :page-count="mailListFrom.totalPage"
              :containerClass="'pagination'"
              :click-handler="clickCallback"
              :prev-text="'Prev'"
              :next-text="'Next'">

                 <span slot="prevContent">previous</span>
                 <span slot="nextContent">nexts</span>
                 <span slot="breakViewContent">
                   <svg width="16" height="4" viewBox="0 0 16 4">
                     <circle fill="#999999" cx="2" cy="2" r="2" />
                     <circle fill="#999999" cx="8" cy="2" r="2" />
                     <circle fill="#999999" cx="14" cy="2" r="2" />
                   </svg>
                 </span>
            </paginate>
        </div>
        </section>
    </section>
    </div>

</template>

<script>

import axios from 'axios'
import VueAdsPagination from 'vue-ads-pagination';

export default {
  // Note: data-name, data-email and data-mobile becomes camel case in props
  props: [
    "dataTotalPage",
    "dataTotalReadPage",
    "dataTotalUnreadPage",
    "dataTotalDeletedPage",
    "dataCurrentPage",
    "dataUserId",
    "dataActionUrl",
    "dataDetailUrl",
    "dataImageUrl",
    'dataCountInbox',
    'dataCountUnreadInbox',
    'dataCountReadInbox',
    'dataCountDeletedInbox',
  ],
  data() {
    return {
        activeClass:'highlight',
        inactiveClass:'read',
        countInbox: this.dataCountInbox,
        countUnreadInbox: this.dataCountUnreadInbox,
        countReadInbox: this.dataCountReadInbox,
        countDeletedInbox: this.dataCountDeletedInbox,
        actionUrl: this.dataActionUrl,
        detailUrl: this.dataDetailUrl,
        messageImage: this.dataImageUrl+'/icon_message.svg',
        deleteImage: this.dataImageUrl+'/icon_garbage.svg',

        mailListFrom: {
            userId: this.dataUserId,
            totalPage: parseInt(this.dataTotalPage),
            currentPage: 1,
            mailStatus: 'all',
            keyword: ''
        },
        updateStatusForm: {
            selectedId: [],
            userId: this.dataUserId,
            mailStatus:''
        },
        mail_list:[]
    };
  },
    mounted() {
        this.getMailList('all',1);
    },
    components: {
        VueAdsPagination,
    },
    methods: {
         getMailDetail: function(mail_id)
         {
             let detail_url = this.detailUrl+'/'+mail_id+'/my_inbox_detail';

             window.location.href= detail_url;
         },
         getMailList(mailStatus, page)
         {
             //assign mail status
             if(mailStatus)
             {
                  this.mailListFrom.mailStatus = mailStatus;
             } else {
                  this.mailListFrom.mailStatus = 'all';
             }
             //assign page
             if(page)
             {
                 this.mailListFrom.currentPage = parseInt(page);
             } else {
                  this.mailListFrom.currentPage = 1;
             }

             //active class
             let arr = ['all','read','unread','deleted'];

             arr.forEach(function(entry)
             {
                 if(entry == mailStatus)
                 {
                      $("#tab_"+mailStatus).addClass( "active" );
                 } else {
                     $("#tab_"+entry).removeClass( "active" );
                 }
             });

             axios.post(this.actionUrl, this.mailListFrom).then(response => {
                     this.mail_list = response.data.data;
                     this.updateStatusForm.selectedId = [];
               }).catch(error => {
                   console.log(error.response);
              });
         },
         mailAction(mailStatus)
         {
              let url = this.detailUrl+'/inbox_mail_action';

             if(this.updateStatusForm.selectedId.length < 1)
             {
                 Swal.fire({
                   type: "warning",
                   title: "Failure",
                   text: "No mail was selected"
                 });
             } else {
                 this.updateStatusForm.mailStatus = mailStatus;

                 axios.post(url, this.updateStatusForm).then(response => {
                      console.log(response.data.message);
                         if(response.data.message == "Success")
                         {
                            Swal.fire({
                               type: "success",
                               title: "Change Status",
                               text: "Selected mail change to "+mailStatus
                           }).then(() => {
                            this.getMailList(this.mailListFrom.mailStatus, 1);
                           });
                         }
                   }).catch(error => {
                       console.log(error.response);
                  });
             }
         },
         clickCallback: function(pageNum) {
              this.getMailList(this.mailListFrom.mailStatus, pageNum);
         },
         check: function(e) {
             $('tbody tr').removeClass("highlight");

             $('tbody td:first-child input').change(function () {
                 $(this).closest('tr').toggleClass("highlight", this.checked);
             });
        }
    }
};
</script>
